module.exports = __webpack_public_path__ + "img/title.be730910.png";